import axios from 'shared/util/axios';

interface AskIdApplication {
  askId: string;
  applicationName: string;
}

interface AskIdPaginationResponse {
  page?: number;
  perPage?: number;
  perpage?: number;
  total?: number;
}

interface AskIdSearchResponse {
  applications?: AskIdApplication[] | null;
  pagination?: AskIdPaginationResponse;
}

const ASK_ID_PAGE_SIZE = 25;

const mapAskIdResponse = (data: AskIdSearchResponse): RootObject => {
  const applications = data.applications ?? [];
  const pagination = data.pagination ?? {};

  return {
    results: applications.map(application => ({
      record: {
        askId: application.askId,
        applicationName: application.applicationName,
      },
    })),
    pagination: {
      page: pagination.page ?? 1,
      perPage: pagination.perPage ?? pagination.perpage ?? ASK_ID_PAGE_SIZE,
      total: pagination.total ?? 0,
    },
  };
};

/**
 * Fetches AIDE application ids from the v4 search endpoint and normalizes the
 * backend response into the legacy shape consumed by the UI.
 *
 * @param search The search term entered by the user.
 * @param page The zero-based page index used by the existing callers.
 * @returns A normalized axios response containing the legacy ask id payload.
 */
const getAskids = (search: string, page: number) => {
  return axios
    .get<AskIdSearchResponse>(
      `/site-builder/v4/apis/aideid/search?searchTerm=${search}&page=${page +
        1}&per_page=${ASK_ID_PAGE_SIZE}`,
      {
        responseType: 'json',
      }
    )
    .then(response => {
      return {
        ...response,
        data: mapAskIdResponse(response.data),
      };
    })
    .catch(error => {
      return error.response;
    });
};

export { getAskids };
